/* eslint-disable camelcase */
import { API } from "./API";

export const getK3Agents = (query) => {
  var {
    id,
    agentId,
    agentIds,
    keyword,
    type,
    main_type,
    status,
    sort_by,
    sort_order,
    limit = 20,
    page = 1
  } = query;

  let queryStr = '';

  if (id)
    queryStr += `&id=${id}`;

  if (agentId)
    queryStr += `&agent_id=${agentId}`;

  if (agentIds)
    queryStr += `&agent_ids=${agentIds}`;

  if (keyword)
    queryStr += `&keyword=${keyword}`;

  if (type)
    queryStr += `&type=${type}`;

  if (main_type)
    queryStr += `&main_type=${main_type}`;

  if (status)
    queryStr += `&status=${status}`;

  if (limit)
    queryStr += `&limit=${limit}`;

  if (page)
    queryStr += `&page=${page}`;

  if (sort_by)
    queryStr += `&sort_by=${sort_by}`;

  if (sort_order)
    queryStr += `&sort_order=${sort_order}`;

  if (queryStr.startsWith('&')) queryStr = queryStr.slice(1);

  return API.get(`${process.env.REACT_APP_API_URL}/api/k3agent?${queryStr}`);
}

export const setK3Agents = (agents, query = {}) => {
    return API.post(`${process.env.REACT_APP_API_URL}/api/k3agent`, agents);
}

export const getK3Logs = (params) => {
  var {
    agentId,
    taskId,
    level,
    limit = 100,
    offset = 0
  } = params;

  var queryStr = '';

  if (agentId)
    queryStr += `&agent_id=${agentId}`;

  if (taskId)
    queryStr += `&task_id=${taskId}`;

  if (level)
    queryStr += `&level=${level}`;

  if (limit)
    queryStr += `&limit=${limit}`;

  if (offset)
    queryStr += `&offset=${offset}`;

  return API.get(`${process.env.REACT_APP_API_URL}/api/k3agent-logs?${queryStr}`);
}

export const assignK3Job = (jobData) => {
  return API.post(`${process.env.REACT_APP_API_URL}/api/k3agent-jobs`, jobData);
}

export const deleteK3Task = (taskId) => {
  return API.delete(`${process.env.REACT_APP_API_URL}/api/k3agent-tasks/${taskId}`);
}

export const updateK3Task = (taskData) => {
  return API.put(`${process.env.REACT_APP_API_URL}/api/k3agent-tasks/${taskData.task_id}`, taskData);
}

export const k3agentService = {
  getK3Agents,
  setK3Agents,
//   getK3Tasks,
  getK3Logs,        
  assignK3Job,
  deleteK3Task,
  updateK3Task
} 